/**
 * BDL Revenda — captcha, honeypot, telefone BR + POST Workflow Webhooks.
 */
(function () {
  'use strict';

  function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function formatBrPhone(value) {
    var digits = digitsOnly(value).slice(0, 11);
    if (!digits.length) return '';
    if (digits.length <= 2) return '(' + digits;
    if (digits.length <= 6) {
      return '(' + digits.slice(0, 2) + ') ' + digits.slice(2);
    }
    if (digits.length <= 10) {
      return (
        '(' +
        digits.slice(0, 2) +
        ') ' +
        digits.slice(2, 6) +
        '-' +
        digits.slice(6)
      );
    }
    return (
      '(' +
      digits.slice(0, 2) +
      ') ' +
      digits.slice(2, 7) +
      '-' +
      digits.slice(7)
    );
  }

  function isValidBrPhone(value) {
    var digits = digitsOnly(value);
    if (digits.length === 10) return /^[1-9][1-9]\d{8}$/.test(digits);
    if (digits.length === 11) return /^[1-9][1-9]9\d{8}$/.test(digits);
    return false;
  }

  function syncPhoneValidity(field) {
    if (!field) return;
    if (!field.value.trim()) {
      field.setCustomValidity('');
      return;
    }
    if (isValidBrPhone(field.value)) {
      field.setCustomValidity('');
    } else {
      field.setCustomValidity('Informe um WhatsApp válido com DDD, no formato (00) 00000-0000.');
    }
  }

  function setupCaptcha(form) {
    var aEl = form.querySelector('[data-revenda-form-captcha-a]');
    var bEl = form.querySelector('[data-revenda-form-captcha-b]');
    var input = form.querySelector('[data-revenda-form-captcha-answer]');
    if (!aEl || !bEl || !input) return null;

    var a = Math.floor(Math.random() * 8) + 1;
    var b = Math.floor(Math.random() * 8) + 1;
    aEl.textContent = String(a);
    bEl.textContent = String(b);
    input.dataset.expected = String(a + b);
    input.value = '';
    return input;
  }

  document.querySelectorAll('[data-bdl-flow-form][data-origem="REVENDA"]').forEach(function (form) {
    var captchaInput = setupCaptcha(form);
    var captchaError = form.querySelector('[data-revenda-form-captcha-error]');
    var honeypot = form.querySelector('[data-revenda-form-honeypot]');
    var phone = form.querySelector('[data-phone-br]');
    var successEl = form.querySelector('[data-bdl-flow-success]');
    var errorEl = form.querySelector('[data-bdl-flow-error]');
    var fieldsEl = form.querySelector('[data-bdl-flow-fields]');
    var actionsEl = form.querySelector('[data-bdl-flow-actions]');
    var submitBtn = form.querySelector('[type="submit"]');

    if (phone) {
      phone.addEventListener('input', function () {
        phone.value = formatBrPhone(phone.value);
        syncPhoneValidity(phone);
      });
      phone.addEventListener('blur', function () {
        phone.dataset.touched = 'true';
        syncPhoneValidity(phone);
      });
    }

    if (captchaInput) {
      captchaInput.addEventListener('input', function () {
        if (captchaError) captchaError.hidden = true;
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (errorEl) errorEl.hidden = true;

      var isHoneypotFilled = !!(honeypot && honeypot.value);
      var expected = captchaInput && captchaInput.dataset.expected;
      var answer = captchaInput ? captchaInput.value.trim() : '';
      var isCaptchaWrong = !expected || answer !== expected;

      if (phone) {
        syncPhoneValidity(phone);
        phone.dataset.touched = 'true';
        if (!phone.checkValidity()) {
          phone.focus();
          return;
        }
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (isHoneypotFilled || isCaptchaWrong) {
        if (captchaError) captchaError.hidden = !isCaptchaWrong;
        if (captchaInput) captchaInput.focus();
        return;
      }

      if (captchaError) captchaError.hidden = true;

      if (!window.BdlFlowWebhook) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.focus();
        }
        return;
      }

      var url = form.getAttribute('data-webhook-url') || '';
      var key = form.getAttribute('data-webhook-key') || '';
      var origem = form.getAttribute('data-origem') || 'REVENDA';
      var payload = window.BdlFlowWebhook.buildPayload(origem, form);

      if (submitBtn) submitBtn.disabled = true;

      window.BdlFlowWebhook.post(url, key, payload)
        .then(function () {
          if (fieldsEl) fieldsEl.hidden = true;
          if (actionsEl) actionsEl.hidden = true;
          if (successEl) {
            successEl.hidden = false;
            successEl.focus();
          }
        })
        .catch(function () {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.focus();
          }
          if (submitBtn) submitBtn.disabled = false;
          setupCaptcha(form);
        });
    });
  });
})();
